import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface FeatureIconProps {
  children: ReactNode;
  gradient?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function FeatureIcon({
  children,
  gradient = 'from-indigo-500/20 to-purple-500/20',
  size = 'md',
  className,
}: FeatureIconProps) {
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  return (
    <div
      className={cn(
        'rounded-xl bg-gradient-to-br flex items-center justify-center',
        'border border-white/[0.07]',
        'shadow-lg shadow-black/10',
        sizeClasses[size],
        gradient,
        className
      )}
    >
      {children}
    </div>
  );
}
